import { useState, useEffect } from 'react';

type TimeOfDay = 'morning' | 'afternoon' | 'evening' | 'night';

interface TimeTheme {
  background: string;
  text: string;
  accent: string;
  name: TimeOfDay;
}

const getTimeOfDay = (): TimeOfDay => {
  const hour = new Date().getHours();
  
  if (hour >= 5 && hour < 12) return 'morning';
  if (hour >= 12 && hour < 17) return 'afternoon';
  if (hour >= 17 && hour < 21) return 'evening';
  return 'night';
};

const getThemeForTime = (timeOfDay: TimeOfDay): TimeTheme => {
  switch (timeOfDay) {
    case 'morning':
      return {
        background: 'bg-slate-900',
        text: 'text-slate-100',
        accent: 'text-cyan-400',
        name: 'morning',
      };
    case 'afternoon':
      return {
        background: 'bg-slate-900',
        text: 'text-slate-100',
        accent: 'text-cyan-400',
        name: 'afternoon',
      };
    case 'evening':
      return {
        background: 'bg-slate-900',
        text: 'text-white',
        accent: 'text-cyan-400',
        name: 'evening',
      };
    case 'night':
      return {
        background: 'bg-slate-900',
        text: 'text-white',
        accent: 'text-cyan-400',
        name: 'night',
      };
    default:
      return {
        background: 'bg-slate-900',
        text: 'text-white',
        accent: 'text-cyan-400',
        name: 'night',
      };
  }
};

export const useTimeTheme = () => {
  const [theme, setTheme] = useState<TimeTheme>(() => {
    const timeOfDay = getTimeOfDay();
    return getThemeForTime(timeOfDay);
  });

  useEffect(() => {
    const updateTheme = () => {
      const timeOfDay = getTimeOfDay();
      setTheme(getThemeForTime(timeOfDay));
    };

    // Update immediately
    updateTheme();

    // Update every minute to catch time changes
    const interval = setInterval(updateTheme, 60000);

    return () => clearInterval(interval);
  }, []);

  return theme;
};
